import { render, staticRenderFns } from "./service.vue?vue&type=template&id=f44c3c28&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"
import style0 from "./service.vue?vue&type=style&index=0&id=f44c3c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44c3c28",
  null
  
)

export default component.exports